<template>
  <Teleport to="body">
    <transition name="fade">
      <div v-if="visible" class="custom-modal-overlay" @click="closeModal">
        <div class="custom-modal" :class="type" @click.stop>
          <div class="modal-icon">
            <i v-if="type === 'success'" class="fa-solid fa-circle-check"></i>
            <i v-else class="fa-solid fa-triangle-exclamation"></i>
          </div>
          <h3 class="modal-title">{{ title }}</h3>
          <div class="modal-content" v-html="sanitizedContent"></div>
          <button class="modal-btn" @click="closeModal">
            {{ type === 'success' ? '好的' : '收到' }}
          </button>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script>
import eventBus from '@/utils/eventBus'
import { sanitizeHtml } from '@/utils/sanitize'

export default {
  name: 'AiResultModal',
  data() {
    return {
      visible: false,
      title: '',
      content: '',
      type: 'success',
    }
  },
  computed: {
    sanitizedContent() {
      return sanitizeHtml(this.content)
    }
  },
  methods: {
    closeModal() {
      this.visible = false
    }
  },
  mounted() {
    eventBus.on('show-ai-result-modal', (params) => {
      if (params) {
        this.title = params.title || ''
        this.content = params.content || ''
        this.type = params.type || 'success'
      }
      this.visible = true
    })
  },
  beforeUnmount() {
    eventBus.off('show-ai-result-modal')
  }
}
</script>

<style scoped>
/* Custom Modal Styles (Root Level) */
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);

  z-index: var(--z-overlay);
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-modal {
  background: #fff;
  border-radius: 12px;
  padding: 30px;
  width: 90%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  animation: modalPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.dark-theme .custom-modal {
  background: #2d2d2d;
  color: #fff;
}

@keyframes modalPop {
  0% { transform: scale(0.8); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

.modal-icon i {
  font-size: 56px;
  margin-bottom: 16px;
}

.custom-modal.success .modal-icon i {
  color: #67c23a;
}

.custom-modal.warning .modal-icon i {
  color: #f56c6c;
}

.modal-title {
  margin: 0 0 16px;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}
.dark-theme .modal-title {
  color: #fff;
}

.modal-content {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  margin-bottom: 24px;
  text-align: left;
}
.dark-theme .modal-content {
  color: #ccc;
}

/* Fix global styles getting scoped */
:deep(.violation-reason) {
  background: #fef0f0;
  color: #f56c6c;
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 8px;
}
.dark-theme :deep(.violation-reason) {
  background: rgba(245, 108, 108, 0.1);
}

:deep(.violation-note) {
  font-size: 12px;
  color: #909399;
}

.modal-btn {
  background: #409eff;
  color: white;
  border: none;
  padding: 10px 30px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  outline: none;
}

.modal-btn:hover {
  background: #66b1ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

.custom-modal.warning .modal-btn {
  background: #f56c6c;
}
.custom-modal.warning .modal-btn:hover {
   background: #f78989;
   box-shadow: 0 4px 12px rgba(245, 108, 108, 0.4);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
